<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="600"
  >
    <v-card>
      <v-toolbar
        dark
      >
        <v-toolbar-title>
          Modify Target - {{targetName}}
        </v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-select
          v-model="packageName"
          :items="packages"
          label="select package"
          outlined
        ></v-select>
      </v-card-text>
      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn color="#f5f5f5" @click="onChangeClick()">Save</v-btn>
        <v-btn color="grey lighten-1" @click="onCancelClick()">Cancel</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    dialog: Boolean,
    targetName: String,
    targetId: Number,
    packageName: String,
    packageIndex: Number,
  },

  data() {
    return {
      packages: [
        'Included',
        'Limited',
        'Premium + VAG',
        'Test',
      ],
      packageLookup: {
        Included: 0,
        Limited: 1,
        'Premium + VAG': 4,
        'Test': 50,
      },
    };
  },

  methods: {
    onChangeClick() {
      const p = this.packageLookup[this.packageName];
      console.log(`subscriptionPackage=${p}`);

      this.$emit('close', {
        targetName: this.targetName,
        targetId: this.targetId,
        packageName: this.packageName,
        packageIndex: p,
      });
    },

    onCancelClick() {
      this.$emit('close', { });
    },
  },
};
</script>
